function ArrowLeftIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3865 11.6136L12.9332 15.0669C12.4132 15.5869 12.4132 16.4269 12.9332 16.9469L16.3865 20.4002C17.2265 21.2402 18.6665 20.6402 18.6665 19.4536V12.5469C18.6665 11.3602 17.2265 10.7736 16.3865 11.6136Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ArrowLeftIcon;
